import { StateManager } from "src/model/manager/state-manager";
import { cartActions } from "./actions/cart.actions";
import { checkoutActions } from "./actions/checkout.actions";
import { marketActions } from "./actions/market.actions";
import { modalManagerActions } from "./actions/modals.actions";
import { profileActions } from "./actions/profile.actions";
import { storeActions } from "./actions/store.actions";
import { CartState, initialCartState } from "./partials/cart.model";
import {
  CheckoutState,
  OrderConfirmationState,
  initialCheckoutState,
  initialOrderConfirmationState,
} from "./partials/checkout.model";
import { MarketState, marketInitialState } from "./partials/market.models";
import { ModalManager, modalManager } from "./partials/modals.models";
import { ProfileState, profileInitialState } from "./partials/profile.model";
import { StoreState, storeInitialState } from "./partials/store.model";
import { navigationInitialState, NavigationState } from "./partials/navigation.model";
import { navigationActions } from "./actions/navigation.actions";

// the type of the app state - Combination of all partial models
export interface AppState {
  market: MarketState;
  navigation: NavigationState;
  store: StoreState;
  profile: ProfileState;
  cart: CartState;
  checkout: CheckoutState;
  orderConfirmation: OrderConfirmationState;
  modals: ModalManager;
}

// the initial state - combination of all states
const initialState: AppState = {
  market: marketInitialState,
  navigation: navigationInitialState,
  store: storeInitialState,
  profile: profileInitialState,
  cart: initialCartState,
  checkout: initialCheckoutState,
  orderConfirmation: initialOrderConfirmationState,
  modals: modalManager,
};

// actions to perform on the state
const actions = {
  ...marketActions,
  ...storeActions,
  ...navigationActions,
  ...profileActions,
  ...cartActions,
  ...checkoutActions,
  ...modalManagerActions,
};

const appStateManager = new StateManager(initialState, actions, true);
const appState = appStateManager.stateFaçade;

export default appState;

(window as any).appState = appState;
